import React from 'react';
import { FloatingTabsStyled } from './floatingTabs.styled';

interface TabsProps {
  value?: string;
  onClick?: (event: React.MouseEvent<HTMLElement>, value: string) => void;
  onClose?: () => void;
  children?: React.ReactNode | React.ReactNode[];
}

const FloatingTabs = ({ value, onClick, onClose, children }: TabsProps) => {
  return (
    <FloatingTabsStyled>
      {React.Children.map(children, (child: React.ReactElement, index) => {
        const childValue =
          child.props.value === undefined ? String(index) : child.props.value;

        return React.cloneElement(child, {
          active: value === childValue,
          onClick,
          onClose,
          ...child.props,
        });
      })}
    </FloatingTabsStyled>
  );
};

FloatingTabs.defaultProps = {
  onChange: () => {},
};

export default FloatingTabs;
